import { defineWidgetSettings } from "@nexus/widget-sdk";
import { ANIMATE_CHART_CONFIG, MISSING_DATA_CONFIG, SUMMARY_BAND_CONFIG } from "@nexus/widget-kit";

/** What an author sets on the CDN/SA account waterfall. */
export const settings = defineWidgetSettings({
  id: "cdnsa-account-waterfall",
  extends: [SUMMARY_BAND_CONFIG, MISSING_DATA_CONFIG, ANIMATE_CHART_CONFIG],
  properties: {
    showStartingBalance: {
      type: "boolean",
      title: "Show starting balance",
      default: true,
      "x-ui": { category: "display", group: "show", order: 10 },
    },
    arrowStyle: {
      type: "string",
      title: "Direction arrows",
      default: "off",
      oneOf: [
        { const: "off", title: "Off" },
        { const: "inside", title: "Inside bars" },
        { const: "shape", title: "Arrow-shaped bars" },
      ],
      "x-ui": { category: "display", order: 30 },
    },
  },
});
